import React, { useState, useEffect } from 'react';

// === DUMMY DATA GENERATOR (150 ITEMS - UNCHANGED) ===
const generateMassiveMenu = () => {
  const baseMenu = {
    "Soups": ["Tomato Basil", "Sweet Corn", "Manchow", "Hot & Sour", "Lemon Coriander", "Mushroom Cream", "Broccoli Almond", "Minestrone", "Clear Veg", "Tom Yum", "Noodle Soup", "Pumpkin Roast", "Spinach Cream", "French Onion", "Asparagus Soup"],
    "Starters": ["Paneer Tikka", "Chilli Paneer", "Veg Manchurian", "Crispy Corn", "Spring Rolls", "Hara Bhara Kebab", "Mushroom Tikka", "Soya Chaap", "Honey Chilli Potato", "Cheese Corn Balls", "Jalapeno Poppers", "Falafel", "Bruschetta", "Garlic Bread", "Stuffed Mushrooms"],
    "Pizzas": ["Margherita", "Farmhouse", "Peppy Paneer", "Mexican Green Wave", "Veg Extravaganza", "Cheese & Corn", "Paneer Makhani", "Tandoori Veg", "Mushroom Delight", "Four Cheese", "BBQ Veg", "Spicy Triple Tango", "Veggie Paradise", "Hawaiian", "Supreme Veg"],
    "Pastas": ["Arrabbiata Penne", "Alfredo Macaroni", "Pesto Spaghetti", "Pink Sauce Penne", "Aglio Olio", "Mac & Cheese", "Lasagna", "Ravioli Spinach", "Fettuccine Alfredo", "Spicy Tomato Fusilli", "Creamy Mushroom", "Baked Pasta", "Penne Vodka Sauce", "Cheesy Garlic Pasta", "Veggie Delight Pasta"],
    "Burgers & Sandwiches": ["Aloo Tikki Burger", "Paneer Burger", "Cheese Burger", "Veggie Double Patty", "Mushroom Burger", "Grilled Veg Sandwich", "Bombay Sandwich", "Club Sandwich", "Paneer Tikka Sandwich", "Spinach Corn Sandwich", "Coleslaw Sandwich", "BBQ Burger", "Crispy Veg Wrap", "Paneer Wrap", "Falafel Wrap"],
    "Main Course (Indian)": ["Dal Makhani", "Dal Tadka", "Paneer Butter Masala", "Kadhai Paneer", "Shahi Paneer", "Palak Paneer", "Mix Veg", "Malai Kofta", "Dum Aloo", "Mushroom Masala", "Bhindi Kurkuri", "Chana Masala", "Navratan Korma", "Mutter Paneer", "Baingan Bharta"],
    "Breads & Rice": ["Tandoori Roti", "Butter Naan", "Garlic Naan", "Lachha Paratha", "Missi Roti", "Cheese Naan", "Steamed Rice", "Jeera Rice", "Veg Pulao", "Veg Biryani", "Hyderabadi Biryani", "Kashmiri Pulao", "Peas Pulao", "Mushroom Fried Rice", "Schezwan Rice"],
    "Chinese Mains": ["Veg Hakka Noodles", "Schezwan Noodles", "Chilli Garlic Noodles", "Pan Fried Noodles", "Veg Fried Rice", "Manchurian Gravy", "Chilli Paneer Gravy", "Sweet & Sour Veg", "Broccoli in Garlic", "Thai Green Curry", "Thai Red Curry", "Pad Thai Noodles", "Stir Fry Veg", "Kung Pao Potato", "Chopsuey"],
    "Beverages": ["Fresh Lime Soda", "Cold Coffee", "Virgin Mojito", "Blue Lagoon", "Green Apple Soda", "Peach Iced Tea", "Lemon Iced Tea", "Masala Chai", "Filter Coffee", "Hot Chocolate", "Red Bull", "Diet Coke", "Watermelon Juice", "Orange Juice", "Pineapple Juice"],
    "Desserts & Shakes": ["Gulab Jamun", "Rasmalai", "Chocolate Brownie", "Cheesecake", "Tiramisu", "Vanilla Ice Cream", "Chocolate Ice Cream", "Strawberry Shake", "Chocolate Shake", "Oreo Shake", "KitKat Shake", "Mango Shake", "Brownie Shake", "Red Velvet Cake", "Mud Pie"]
  };

  let basePriceCounter = 120;
  return Object.keys(baseMenu).map((cat) => {
    basePriceCounter += 20;
    return {
      category: cat,
      items: baseMenu[cat as keyof typeof baseMenu].map((item, idx) => ({
        name: item,
        price: `₹${basePriceCounter + (idx * 15)}`,
        desc: idx % 4 === 0 ? "Chef's highly recommended special." : "Prepared fresh with premium ingredients."
      }))
    };
  });
};

const massiveMenu = generateMassiveMenu();

// === MAIN COMPONENT ===
const CafeMidTier: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<'home' | 'menu' | 'about' | 'reservation' | 'contact'>('home');
  const [isReserved, setIsReserved] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const handleReservation = (e: React.FormEvent) => {
    e.preventDefault();
    setIsReserved(true);
    setTimeout(() => setIsReserved(false), 5000);
  };

  return (
    <div className="min-h-screen bg-[#FDFCFB] text-stone-900 font-sans flex flex-col selection:bg-orange-200">
      
      {/* --- NAVBAR --- */}
      <nav className="bg-white/95 backdrop-blur-md sticky top-0 z-50 shadow-sm border-b border-stone-100">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <div className="flex items-center gap-2 cursor-pointer group" onClick={() => setCurrentPage('home')}>
             <span className="text-3xl text-orange-600 group-hover:rotate-12 transition-transform">🌿</span>
             <span className="text-2xl font-serif font-bold tracking-tight">The Rustic <span className="font-light text-orange-600">Cafe</span></span>
          </div>
          
          <div className="hidden md:flex gap-8 text-xs font-bold uppercase tracking-[0.2em] text-stone-500">
            {['home', 'menu', 'about', 'contact'].map(page => (
              <button 
                key={page} 
                onClick={() => setCurrentPage(page as any)}
                className={`hover:text-orange-600 transition ${currentPage === page ? 'text-stone-900 border-b-2 border-orange-600 pb-1' : ''}`}
              >
                {page}
              </button>
            ))}
          </div>

          <button onClick={() => setCurrentPage('reservation')} className="bg-stone-900 text-white px-6 py-3 rounded-full text-xs font-bold uppercase tracking-[0.15em] hover:bg-orange-600 transition shadow-lg">
            Reserve Table
          </button>
        </div>
      </nav>

      {/* --- PAGE CONTENT AREA --- */}
      <main className="flex-grow animate-fadeIn">
        
        {/* ================= 1. HOME PAGE (EXPANDED) ================= */}
        {currentPage === 'home' && (
          <div className="animate-slideUp">
            
            {/* Hero */}
            <header className="relative h-[90vh] flex items-center justify-center text-center px-6">
              <div className="absolute inset-0 bg-stone-900">
                <img src="https://images.unsplash.com/photo-1554118811-1e0d58224f24?q=80&w=1600&auto=format&fit=crop" alt="Cafe" className="w-full h-full object-cover opacity-50"/>
              </div>
              <div className="relative z-10 max-w-4xl space-y-6">
                <span className="bg-orange-600/90 backdrop-blur-sm text-white px-5 py-2 rounded-full text-xs font-bold uppercase tracking-widest border border-orange-400">Farm to Table Experience</span>
                <h1 className="text-6xl md:text-8xl font-serif text-white font-bold drop-shadow-2xl leading-tight">Where Good Food <br/><span className="italic font-light text-orange-200">Meets Great Coffee.</span></h1>
                <p className="text-stone-200 text-xl font-light max-w-2xl mx-auto drop-shadow-md">Experience the perfect blend of taste and ambiance. Order directly from us to save on delivery fees, or reserve your table for a memorable evening.</p>
                <div className="pt-8 flex flex-col sm:flex-row justify-center gap-5">
                  <button onClick={() => setCurrentPage('menu')} className="bg-white text-stone-900 px-10 py-4 rounded-full font-bold uppercase tracking-[0.15em] hover:bg-stone-100 transition text-sm shadow-xl">Explore Menu</button>
                  <button onClick={() => setCurrentPage('reservation')} className="border-2 border-white/80 backdrop-blur-sm text-white px-10 py-4 rounded-full font-bold uppercase tracking-[0.15em] hover:bg-white hover:text-stone-900 transition text-sm">Book A Table</button>
                </div>
              </div>
            </header>

            {/* NEW: Brand Philosophy */}
            <section className="py-24 px-6 bg-white text-center max-w-4xl mx-auto space-y-8">
              <span className="text-orange-600 text-4xl">✧</span>
              <h2 className="text-4xl font-serif text-stone-900">A Symphony of Flavors</h2>
              <p className="text-stone-500 text-xl leading-relaxed font-light">Every dish we serve is a testament to our love for culinary arts. We don't just cook; we craft experiences using hand-picked organic ingredients, ensuring every bite tells a story of freshness and passion.</p>
            </section>
            
            {/* Featured Categories */}
            <section className="py-24 px-6 bg-stone-50 border-y border-stone-100">
              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                  <span className="text-orange-600 font-bold uppercase tracking-widest text-xs">Must Try</span>
                  <h2 className="text-5xl font-serif text-stone-900 mt-2">Cafe Favorites</h2>
                </div>
                <div className="grid md:grid-cols-3 gap-8">
                  {[
                    { t: 'Artisan Pizzas', d: 'Hand-tossed & wood-fired.', i: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?q=80&w=600' },
                    { t: 'Fresh Brews', d: 'Locally roasted beans.', i: 'https://images.unsplash.com/photo-1497935586351-b67a49e012bf?q=80&w=600' },
                    { t: 'Healthy Bowls', d: 'Organic & guilt-free.', i: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?q=80&w=600' }
                  ].map((box, idx) => (
                    <div key={idx} onClick={() => setCurrentPage('menu')} className="cursor-pointer group relative h-[400px] rounded-[2rem] overflow-hidden shadow-xl">
                      <img src={box.i} alt={box.t} className="w-full h-full object-cover group-hover:scale-110 transition duration-700"/>
                      <div className="absolute inset-0 bg-gradient-to-t from-stone-900 via-stone-900/20 to-transparent flex flex-col justify-end p-8">
                        <h3 className="text-white text-3xl font-serif">{box.t}</h3>
                        <p className="text-stone-300 mt-2 opacity-0 group-hover:opacity-100 transition duration-500 delay-100">{box.d}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* NEW: Chef's Spotlight */}
            <section className="py-24 px-6 bg-white max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
              <div className="relative h-[600px] rounded-[3rem] overflow-hidden shadow-2xl border-4 border-stone-50">
                <img src="https://img.freepik.com/premium-photo/chefs-signature-dishes-culinary-art-its-finest_1274913-3236.jpg?w=1380" alt="Chef's Special" className="w-full h-full object-cover"/>
                <div className="absolute top-6 right-6 bg-white/90 backdrop-blur-md p-4 rounded-2xl shadow-lg text-center">
                  <span className="block text-2xl font-bold text-stone-900">₹450</span>
                  <span className="text-[10px] uppercase tracking-widest text-orange-600 font-bold">Signature Dish</span>
                </div>
              </div>
              <div className="space-y-6">
                <span className="text-orange-600 font-bold uppercase tracking-widest text-sm">Chef's Spotlight</span>
                <h2 className="text-5xl font-serif text-stone-900 leading-tight">Truffle Mushroom Risotto</h2>
                <p className="text-stone-600 text-lg leading-relaxed">Slow-cooked arborio rice infused with wild mushrooms, parmesan cheese, and a drizzle of authentic Italian white truffle oil. A dish that promises to transport you straight to the heart of Rome.</p>
                <button onClick={() => setCurrentPage('menu')} className="mt-4 border-b-2 border-stone-900 pb-1 text-stone-900 font-bold uppercase tracking-widest hover:text-orange-600 hover:border-orange-600 transition">View Full Menu ➔</button>
              </div>
            </section>

            {/* NEW: Testimonials */}
            <section className="py-24 px-6 bg-stone-900 text-white text-center">
              <div className="max-w-4xl mx-auto space-y-12">
                <span className="text-orange-500 font-bold uppercase tracking-widest text-sm">Loved by Locals</span>
                <h2 className="text-5xl font-serif">What Our Guests Say</h2>
                <div className="bg-stone-800/50 p-10 md:p-16 rounded-[3rem] border border-stone-700 relative">
                  <span className="text-8xl text-stone-700 absolute top-4 left-8 font-serif leading-none">"</span>
                  <p className="text-2xl font-light italic leading-relaxed relative z-10 text-stone-200">The ambiance is absolutely magical and the food is out of this world. The staff makes you feel like family. Easily the best cafe in the city!</p>
                  <div className="mt-8 flex flex-col items-center">
                    <span className="text-orange-500 text-xl">★★★★★</span>
                    <span className="font-bold uppercase tracking-widest text-xs mt-3">Anjali Sharma</span>
                    <span className="text-stone-500 text-xs mt-1">Local Food Blogger</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}

        {/* ================= 2. MENU PAGE (UNCHANGED 150 ITEMS) ================= */}
        {currentPage === 'menu' && (
          <div className="animate-slideUp bg-[#FFFDFB] py-16 px-6">
            <div className="max-w-7xl mx-auto text-center mb-16">
              <h1 className="text-5xl md:text-6xl font-serif font-bold text-stone-900">Our Culinary Menu</h1>
              <p className="text-stone-500 mt-4 text-lg">150+ Dishes curated for your cravings.</p>
            </div>
            
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-12">
              <div className="md:w-1/4">
                <div className="sticky top-28 bg-white p-6 rounded-3xl shadow-sm border border-stone-100">
                  <h3 className="font-bold uppercase tracking-widest text-sm mb-6 text-orange-600">Categories</h3>
                  <ul className="space-y-4 text-stone-600 font-medium">
                    {massiveMenu.map((m, i) => (
                      <li key={i} className="hover:text-stone-900 cursor-pointer transition flex justify-between">
                        <a href={`#cat-${i}`}>{m.category}</a>
                        <span className="text-xs bg-stone-100 px-2 py-1 rounded-full text-stone-400">{m.items.length}</span>
                      </li>
                    ))}
                  </ul>
                  <button onClick={() => setCurrentPage('contact')} className="w-full mt-8 bg-stone-900 text-white py-4 rounded-xl font-bold uppercase tracking-widest text-xs hover:bg-stone-800 transition">📞 Direct Order</button>
                </div>
              </div>

              <div className="md:w-3/4 space-y-16">
                {massiveMenu.map((section, idx) => (
                  <div key={idx} id={`cat-${idx}`} className="scroll-mt-28">
                    <h2 className="text-3xl font-serif font-bold text-stone-900 mb-8 border-b-2 border-stone-100 pb-4">{section.category}</h2>
                    <div className="grid sm:grid-cols-2 gap-x-12 gap-y-8">
                      {section.items.map((item, iIdx) => (
                        <div key={iIdx} className="flex justify-between items-start group">
                          <div className="pr-4">
                            <h4 className="text-base font-bold text-stone-800 group-hover:text-orange-600 transition">{item.name}</h4>
                            <p className="text-xs text-stone-500 mt-1">{item.desc}</p>
                          </div>
                          <span className="text-base font-bold text-orange-700 whitespace-nowrap">{item.price}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ================= 3. ABOUT PAGE (EXPANDED) ================= */}
        {currentPage === 'about' && (
          <div className="animate-slideUp">
            
            {/* Story Section */}
            <section className="py-24 px-6 max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
              <div className="space-y-6">
                <span className="text-orange-600 font-bold uppercase tracking-widest text-sm">Our Roots</span>
                <h1 className="text-5xl md:text-6xl font-serif font-bold text-stone-900 leading-tight">Serving Happiness Since 2015.</h1>
                <p className="text-stone-600 text-lg leading-relaxed">What started as a tiny 4-table coffee shop has blossomed into the city's favorite artisan dining space. Our journey is fueled by a simple belief: good food has the power to bring people together.</p>
                <div className="border-l-4 border-orange-500 pl-6 my-8">
                  <p className="text-2xl font-serif italic text-stone-800">"We don't just serve meals; we serve memories on a plate."</p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-6 h-[600px]">
                <img src="https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=600" alt="Cafe Owner" className="w-full h-full object-cover rounded-[2rem] mt-12 shadow-xl"/>
                <img src="https://images.unsplash.com/photo-1600891964092-4316c288032e?q=80&w=600" alt="Cooking" className="w-full h-full object-cover rounded-[2rem] mb-12 shadow-xl"/>
              </div>
            </section>

            {/* NEW: Core Values */}
            <section className="py-24 px-6 bg-stone-900 text-white">
              <div className="max-w-7xl mx-auto text-center">
                <h2 className="text-4xl font-serif mb-16">The Pillars of The Rustic Cafe</h2>
                <div className="grid md:grid-cols-3 gap-12">
                  <div className="space-y-4">
                    <span className="text-5xl block mb-6">🌱</span>
                    <h3 className="text-2xl font-serif text-orange-400">100% Organic</h3>
                    <p className="text-stone-400 leading-relaxed">We source our vegetables and dairy directly from local farmers, ensuring zero pesticides and maximum nutrition.</p>
                  </div>
                  <div className="space-y-4">
                    <span className="text-5xl block mb-6">🤝</span>
                    <h3 className="text-2xl font-serif text-orange-400">Community First</h3>
                    <p className="text-stone-400 leading-relaxed">Our space is designed to be a hub for creators, families, and friends to connect over a warm cup of coffee.</p>
                  </div>
                  <div className="space-y-4">
                    <span className="text-5xl block mb-6">👨‍🍳</span>
                    <h3 className="text-2xl font-serif text-orange-400">Artisan Craft</h3>
                    <p className="text-stone-400 leading-relaxed">No microwaves, no shortcuts. From our bread to our sauces, everything is crafted from scratch daily.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* NEW: Meet the Chef */}
            <section className="py-24 px-6 bg-stone-50 max-w-7xl mx-auto grid md:grid-cols-12 gap-12 items-center">
              <div className="md:col-span-5 h-[500px]">
                 <img src="https://images.unsplash.com/photo-1577219491135-ce391730fb2c?q=80&w=600&auto=format&fit=crop" alt="Head Chef" className="w-full h-full object-cover rounded-[2rem] shadow-lg grayscale hover:grayscale-0 transition duration-700"/>
              </div>
              <div className="md:col-span-7 space-y-6 md:pl-10">
                <span className="text-orange-600 font-bold uppercase tracking-widest text-sm">The Mastermind</span>
                <h2 className="text-5xl font-serif text-stone-900">Chef Rahul Kapoor</h2>
                <p className="text-stone-600 text-lg leading-relaxed">With over 15 years of culinary experience across Europe and Asia, Chef Rahul brings a global touch to local flavors. His passion for fusion cuisine is the heartbeat of our massive 150+ item menu.</p>
                <button onClick={() => setCurrentPage('menu')} className="bg-stone-900 text-white px-8 py-4 rounded-full font-bold uppercase tracking-widest text-xs hover:bg-orange-600 transition shadow-lg mt-4">Taste His Creations</button>
              </div>
            </section>
          </div>
        )}

        {/* ================= 4. RESERVATION PAGE (WITH EXTRA INFO) ================= */}
        {currentPage === 'reservation' && (
          <div className="animate-slideUp py-24 px-6 bg-stone-100">
            <div className="max-w-5xl mx-auto">
              <div className="bg-white rounded-[3rem] shadow-2xl overflow-hidden flex flex-col md:flex-row mb-16">
                <div className="md:w-2/5 bg-stone-900 text-white p-12 flex flex-col justify-center relative overflow-hidden">
                  <div className="absolute inset-0 opacity-20"><img src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=600" className="w-full h-full object-cover" alt="bg"/></div>
                  <div className="relative z-10">
                    <h2 className="text-4xl font-serif mb-6">Reserve Your Table</h2>
                    <p className="text-stone-300 mb-8 leading-relaxed">Skip the waiting line. Book your table in advance for a flawless dining experience.</p>
                    <div className="space-y-4 text-sm font-bold tracking-widest uppercase">
                      <p className="flex items-center gap-3"><span className="text-orange-500 text-xl">📞</span> +91 98765 43210</p>
                      <p className="flex items-center gap-3"><span className="text-orange-500 text-xl">🕒</span> 11:00 AM - 11:00 PM</p>
                    </div>
                  </div>
                </div>
                <div className="md:w-3/5 p-12">
                  {isReserved ? (
                    <div className="h-full flex flex-col items-center justify-center text-center space-y-4 py-10">
                      <div className="w-24 h-24 bg-green-50 text-green-600 rounded-full flex items-center justify-center text-5xl mb-4">✓</div>
                      <h3 className="text-3xl font-serif font-bold text-stone-900">Table Confirmed!</h3>
                      <p className="text-stone-500 text-lg">We have received your reservation. A confirmation SMS has been sent.</p>
                      <button onClick={() => setIsReserved(false)} className="text-orange-600 font-bold uppercase tracking-widest text-xs mt-6 border-b border-orange-600 pb-1">Make another booking</button>
                    </div>
                  ) : (
                    <form onSubmit={handleReservation} className="space-y-6">
                      <div className="grid sm:grid-cols-2 gap-6">
                        <div><label className="block text-xs font-bold uppercase tracking-widest text-stone-500 mb-2">Name</label><input required type="text" className="w-full bg-stone-50 border border-stone-200 p-4 rounded-xl focus:border-orange-500 outline-none"/></div>
                        <div><label className="block text-xs font-bold uppercase tracking-widest text-stone-500 mb-2">Phone</label><input required type="tel" className="w-full bg-stone-50 border border-stone-200 p-4 rounded-xl focus:border-orange-500 outline-none"/></div>
                      </div>
                      <div className="grid sm:grid-cols-2 gap-6">
                        <div><label className="block text-xs font-bold uppercase tracking-widest text-stone-500 mb-2">Date</label><input required type="date" className="w-full bg-stone-50 border border-stone-200 p-4 rounded-xl focus:border-orange-500 outline-none text-stone-700"/></div>
                        <div><label className="block text-xs font-bold uppercase tracking-widest text-stone-500 mb-2">Time</label><input required type="time" className="w-full bg-stone-50 border border-stone-200 p-4 rounded-xl focus:border-orange-500 outline-none text-stone-700"/></div>
                      </div>
                      <div>
                        <label className="block text-xs font-bold uppercase tracking-widest text-stone-500 mb-2">Number of Guests</label>
                        <select className="w-full bg-stone-50 border border-stone-200 p-4 rounded-xl focus:border-orange-500 outline-none text-stone-700">
                          <option>1 - 2 People</option><option>3 - 4 People</option><option>5 - 8 People</option><option>Large Group (8+)</option>
                        </select>
                      </div>
                      <button type="submit" className="w-full bg-orange-600 text-white font-bold uppercase tracking-[0.15em] py-5 rounded-xl hover:bg-orange-700 transition shadow-xl mt-4">Confirm Booking</button>
                    </form>
                  )}
                </div>
              </div>

              {/* Private Events Info */}
              <div className="text-center max-w-2xl mx-auto">
                 <h3 className="text-2xl font-serif text-stone-900 mb-2">Hosting a Party?</h3>
                 <p className="text-stone-600 mb-4">We offer private dining spaces for birthdays, corporate events, and anniversaries. Customized 150+ menu catering available.</p>
                 <button onClick={() => setCurrentPage('contact')} className="text-orange-600 font-bold uppercase tracking-widest text-xs underline">Contact for Event Booking</button>
              </div>
            </div>
          </div>
        )}

        {/* ================= 5. CONTACT PAGE ================= */}
        {currentPage === 'contact' && (
          <div className="animate-slideUp py-24 px-6 max-w-7xl mx-auto grid md:grid-cols-2 gap-16">
            <div className="space-y-8">
              <span className="bg-orange-100 text-orange-800 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest">Save 30% on Delivery Apps</span>
              <h1 className="text-5xl font-serif font-bold text-stone-900">Direct Order & Visit</h1>
              <p className="text-stone-600 text-lg">Don't pay extra commissions. Call us directly or message us on WhatsApp for fast, free delivery within 5km of our cafe.</p>
              
              <div className="space-y-6 pt-4">
                <div className="flex gap-5 p-8 bg-white border border-stone-100 rounded-3xl shadow-lg">
                  <span className="text-4xl text-orange-600">📞</span>
                  <div><h3 className="font-bold text-stone-900 uppercase tracking-widest text-sm">Call for Delivery</h3><p className="text-2xl font-bold text-orange-600 mt-1">+91 98765 43210</p></div>
                </div>
                <div className="flex gap-5 p-8 bg-white border border-stone-100 rounded-3xl shadow-lg">
                  <span className="text-4xl text-green-500">💬</span>
                  <div><h3 className="font-bold text-stone-900 uppercase tracking-widest text-sm">WhatsApp Order</h3><p className="text-stone-500 mt-1">Send us your dish names, we will reply with bill & tracking.</p></div>
                </div>
                <div className="flex gap-5 p-8 bg-white border border-stone-100 rounded-3xl shadow-lg">
                  <span className="text-4xl text-stone-800">📍</span>
                  <div><h3 className="font-bold text-stone-900 uppercase tracking-widest text-sm">Dine-in Address</h3><p className="text-stone-500 mt-1">Shop 101, Central Mall Road,<br/>Opposite Metro Pillar 42, Ghaziabad</p></div>
                </div>
              </div>
            </div>
            <div className="h-[600px] bg-stone-300 rounded-[3rem] overflow-hidden shadow-2xl border-8 border-white relative">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14008.114827184043!2d77.21595625!3d28.6295706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd37b741d057%3A0xc46188cbcc01452!2sConnaught%20Place%2C%20New%20Delhi%2C%20Delhi%20110001!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" className="w-full h-full grayscale hover:grayscale-0 transition duration-700"></iframe>
            </div>
          </div>
        )}

      </main>

      {/* ================= ULTRA-PREMIUM EXPANDED FOOTER ================= */}
      
      {/* 1. Instagram Feed Strip (Pre-footer) */}
     {/* 1. Instagram Feed Strip (Pre-footer) */}
{/* 1. Instagram Feed Strip (Pre-footer) */}
{/* 1. Instagram Feed Strip (Pre-footer) */}
      <div className="w-full grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 mt-16">
        {[
          '1568901346375-23c9450c58cd', // 1. Yummy Burger (Working)
          '1504630083234-14187a9df0f5', // 2. Coffee Cup (Working)
          '1512621776951-a57141f2eefd', // 3. Healthy Salad Bowl (NEW - 100% Working)
          '1565299624946-b28f40a0ae38', // 4. Pizza (Working)
          '1473093295043-cdd812d0e601', // 5. Pasta (Working)
          '1497935586351-b67a49e012bf'  // 6. Coffee Tools (Working)
        ].map((id, index) => (
           <a key={index} href="#" className="relative group block aspect-square overflow-hidden bg-stone-900">
              <img 
                src={`https://images.unsplash.com/photo-${id}?q=80&w=400&auto=format&fit=crop`} 
                alt={`Instagram Feed ${index + 1}`} 
                className="w-full h-full object-cover group-hover:opacity-40 transition duration-500"
              />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-500 text-white font-bold tracking-widest text-sm">
                @RUSTICCAFE
              </div>
           </a>
        ))}
      </div>

      <footer className="w-full bg-white font-sans text-stone-800">
        
        {/* 2. As Seen In */}
        <div className="py-20 text-center max-w-6xl mx-auto px-6">
          <h3 className="text-xs tracking-[0.3em] uppercase font-bold mb-12 text-stone-400">Trusted By Local Foodies & Media</h3>
          <div className="flex flex-wrap justify-center items-center gap-10 md:gap-20 opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
            <span className="text-3xl font-black tracking-tighter">Zomato</span>
            <span className="text-3xl font-bold tracking-tight text-orange-500">Swiggy</span>
            <span className="text-3xl font-serif font-bold italic text-stone-900">FoodTimes</span>
            <span className="text-2xl font-sans font-light tracking-widest uppercase">CityGuide</span>
          </div>
        </div>

        {/* 3. Main Mega Footer Band */}
        <div className="bg-[#FAEBE4] py-20 px-6 relative border-t border-[#f1dcd2]">
          <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-start">
            
            {/* Logo & Intro */}
            <div className="lg:col-span-4 space-y-6">
              <div className="text-5xl font-serif font-bold text-stone-900 select-none">
                The Rustic Cafe.
              </div>
              <p className="text-stone-600 leading-relaxed pr-4">Crafting artisan meals and brewing organic coffee since 2015. Your go-to neighborhood spot for great vibes and better food.</p>
              <div className="flex items-center gap-4 text-stone-900 pt-2">
                <span className="w-10 h-10 bg-white rounded-full flex items-center justify-center font-bold text-xs hover:bg-orange-600 hover:text-white transition cursor-pointer shadow-sm">IG</span>
                <span className="w-10 h-10 bg-white rounded-full flex items-center justify-center font-bold text-xs hover:bg-orange-600 hover:text-white transition cursor-pointer shadow-sm">FB</span>
                <span className="w-10 h-10 bg-white rounded-full flex items-center justify-center font-bold text-xs hover:bg-orange-600 hover:text-white transition cursor-pointer shadow-sm">WA</span>
              </div>
            </div>

            {/* Links */}
            <div className="lg:col-span-2">
              <h4 className="font-bold uppercase tracking-widest text-xs text-stone-900 mb-6">Quick Links</h4>
              <ul className="space-y-4 text-sm font-medium text-stone-600">
                {['Home', 'Menu', 'About Us', 'Reservation', 'Contact'].map(link => (
                  <li key={link}><button onClick={() => setCurrentPage(link.split(' ')[0].toLowerCase() as any)} className="hover:text-orange-600 transition">{link}</button></li>
                ))}
              </ul>
            </div>

            {/* Timings */}
            <div className="lg:col-span-2">
              <h4 className="font-bold uppercase tracking-widest text-xs text-stone-900 mb-6">Visit Us</h4>
              <ul className="space-y-4 text-sm font-medium text-stone-600">
                <li>Monday - Friday<br/><span className="text-stone-900 font-bold mt-1 block">11:00 AM - 10:30 PM</span></li>
                <li>Saturday - Sunday<br/><span className="text-stone-900 font-bold mt-1 block">10:00 AM - 11:30 PM</span></li>
              </ul>
            </div>

            {/* Newsletter */}
            <div className="lg:col-span-4">
              <h4 className="font-bold uppercase tracking-widest text-xs text-stone-900 mb-6">Join The Club</h4>
              <p className="text-sm text-stone-600 mb-4">Subscribe to get secret menu items, early event access, and a 10% off coupon!</p>
              <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); alert('Subscribed!'); }}>
                <input type="email" placeholder="Email Address" required className="flex-grow px-4 py-3 rounded-xl border border-[#e8d5cc] focus:outline-none focus:border-orange-500 bg-white/50 backdrop-blur-sm" />
                <button type="submit" className="bg-stone-900 text-white px-6 py-3 rounded-xl font-bold uppercase tracking-widest text-xs hover:bg-orange-600 transition">Join</button>
              </form>
            </div>

          </div>
        </div>

        {/* 4. Bottom Copyright */}
        <div className="py-8 px-6 bg-stone-950 text-white">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
            <p className="text-[10px] uppercase tracking-widest font-bold text-stone-400">
              © {new Date().getFullYear()} THE RUSTIC CAFE. ALL RIGHTS RESERVED.
            </p>
            <div className="flex gap-6 text-[10px] uppercase tracking-widest font-bold text-stone-500">
               <a href="#" className="hover:text-white transition">Privacy Policy</a>
               <a href="#" className="hover:text-white transition">Terms of Service</a>
               <span className="text-orange-600">Premium Demo</span>
            </div>
          </div>
        </div>
        
      </footer>

      {/* Animations */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .animate-slideUp { animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
      `}} />
    </div>
  );
};

export default CafeMidTier;